/**
 * NotFoundPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 */

import React from "react";
import "./style.module.css";

export default function NotFound() {
  return (
    <article>
      <h1>Page not found.</h1>
    </article>
  );
}
